import script from "./customStyleItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./customStyleItem.vue?vue&type=script&lang=ts&setup=true"

import "./customStyleItem.vue?vue&type=style&index=0&id=5400975c&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5400975c"]])

export default __exports__